"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDarkMode = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useDarkMode = function useDarkMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === void 0 ? false : _ref$initialValue,
      _ref$darkModeClass = _ref.darkModeClass,
      darkModeClass = _ref$darkModeClass === void 0 ? 'dark' : _ref$darkModeClass,
      _ref$lightModeClass = _ref.lightModeClass,
      lightModeClass = _ref$lightModeClass === void 0 ? 'light' : _ref$lightModeClass,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'body' : _ref$element,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug;

  var _useState = (0, _react.useState)(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      isDarkMode = _useState2[0],
      setDarkMode = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      elm = _useState4[0],
      setElm = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      _document = _useState6[0],
      setDocument = _useState6[1];

  var toggleDarkMode = function toggleDarkMode() {
    var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var theme = on ? darkModeClass : lightModeClass;

    if (elm && !elm.classList.contains(theme)) {
      elm.classList.add(theme);
      var oppositeTheme = on ? lightModeClass : darkModeClass;

      if (elm.classList.contains(oppositeTheme)) {
        elm.classList.remove(oppositeTheme);
      }
    }

    localStorage.setItem('theme', theme);

    if (isDarkMode !== on) {
      setDarkMode(on);
    }
  };

  (0, _react.useEffect)(function () {
    setDocument(document);
  }, []);
  (0, _react.useEffect)(function () {
    if (_document) {
      setElm(_document.querySelector(element));
    }
  }, [element, _document]);
  (0, _react.useEffect)(function () {
    if (debug) {
      if (!elm) {
        console.error("useDarkMode ERROR: ".concat(element, " is not defined in the document"));
        return;
      } else {
        console.log("useDarkMode: ".concat(element, " is set."));
      }
    }
  }, [elm, debug]);
  (0, _react.useEffect)(function () {
    var theme = localStorage.getItem('theme');

    if (!theme) {
      theme = lightModeClass; //default value
    }

    toggleDarkMode(theme === darkModeClass);
  }, [lightModeClass, darkModeClass, elm]);
  return [isDarkMode, toggleDarkMode];
};

exports.useDarkMode = useDarkMode;